import { render, staticRenderFns } from "./FxHistoryTable.vue?vue&type=template&id=6e68bee2&"
import script from "./FxHistoryTable.vue?vue&type=script&lang=js&"
export * from "./FxHistoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports